<app-global-loader></app-global-loader>
<app-sidenavbar *ngIf="isLoggedIn && !isModulesPage"></app-sidenavbar>
<div id="main">
  <!-- <div class="d-flex"> -->
  <!-- <div *ngIf="!router.url.includes('authentication')" class="resizer" id="resizer"></div>  test-->
  <!-- <div> -->
  <app-header *ngIf="isLoggedIn"></app-header>
  <app-page-loader *ngIf="isLoading"></app-page-loader>
  <app-notif-panel *ngIf="isLoggedIn && !isNotifPanelHide"></app-notif-panel>
  
  <router-outlet></router-outlet>
  <app-chatbot></app-chatbot>
  <!-- </div> -->
</div>
<!-- </div> -->
